import { Facility, FacilityType } from '@schooly/api';

export interface CategorizedFacilities<T extends Pick<Facility, 'id' | 'type' | 'parent_id'>> {
  campuses: T[];
  buildings: T[];
  rooms: T[];
  standaloneBuildings: T[];
  standaloneRooms: T[];
  childrenByParentId: Record<string, T[]>;
}

export const categorizeFacilities = <T extends Pick<Facility, 'id' | 'type' | 'parent_id'>>(
  facilities: T[],
): CategorizedFacilities<T> => {
  const result: CategorizedFacilities<T> = {
    campuses: [],
    buildings: [],
    rooms: [],
    standaloneBuildings: [],
    standaloneRooms: [],
    childrenByParentId: {},
  };

  for (const f of facilities) {
    if (f.parent_id) {
      const children = result.childrenByParentId[f.parent_id] ?? [];
      children.push(f);
      result.childrenByParentId[f.parent_id] = children;
    }

    switch (f.type) {
      case FacilityType.Campus:
        result.campuses.push(f);
        break;
      case FacilityType.Building:
        result.buildings.push(f);
        if (!f.parent_id) result.standaloneBuildings.push(f);
        break;
      case FacilityType.Room:
        result.rooms.push(f);
        if (!f.parent_id) result.standaloneRooms.push(f);
        break;
    }
  }

  return result;
};

export const getChildrenByParentId = <T>(
  childrenByParentId: Record<string, T[]>,
  parentId: string,
): T[] => childrenByParentId[parentId] ?? [];

export const sortFacilities = <T extends Pick<Facility, 'name'>>(facilities: T[]): T[] =>
  [...facilities].sort((a, b) =>
    a.name.localeCompare(b.name, undefined, { sensitivity: 'base', numeric: true }),
  );
